import { render, staticRenderFns } from "./Beef.vue?vue&type=template&id=37228b5e&"
import script from "./Beef.vue?vue&type=script&lang=js&"
export * from "./Beef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports